<template>
  <div class="title-bar">
    <div class="title-bar__title-wrapper">
      <h4 class="title-bar__title">
        {{ type === 'exam' ? 'CERTIFICATION EXAM' : '' }}
      </h4>
    </div>
    <XIcon @click="$emit('close-modal')" class="title-bar__close" />
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons'

export default {
  name: 'TitleBarMobile',
  components: {
    XIcon,
  },
  data() {
    return {}
  },
  props: {
    type: {
      type: String,
      required: false,
      default() {
        return 'quiz'
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.title-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  max-width: 2400px;
  z-index: 204;
  position: relative;
  background: transparent;
  padding: 20px;

  &__title-wrapper {
    width: 100%;
  }
  &__title {
    margin: 0;
    padding: 0;
    font-size: 1rem;
    line-height: 1.5rem;
  }
  &__close {
    margin-left: 30px;
    cursor: pointer;
  }
}
</style>
